import { render, staticRenderFns } from "./AdultNewTabBar.vue?vue&type=template&id=6c850e6b&scoped=true"
import script from "./AdultNewTabBar.vue?vue&type=script&lang=js"
export * from "./AdultNewTabBar.vue?vue&type=script&lang=js"
import style0 from "./AdultNewTabBar.vue?vue&type=style&index=0&id=6c850e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c850e6b",
  null
  
)

export default component.exports